import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { Component, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/_services/products.service';
import { ReportsService } from 'src/app/_services/reports.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-stock-management-v2',
  templateUrl: './product-stock-management-v2.component.html',
  styleUrls: ['./product-stock-management-v2.component.scss']
})
export class ProductStockManagementV2Component implements OnInit {
  data: any = ''
  loading = false
  totalStockOnHands = 0
  activeVariantLocation: any = null
  private pendingVariantStockEntries: any[] = []
  private serverMappedVariantRowIds = new Set<string>()

  constructor(
    public _reportService: ReportsService,
    public _productService: ProductsService,
    public _abd: AppBaseDataService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
    if (this._abd.locations.length) {

      const x = this._abd.initActLocations()
      this._abd.initLocations(x)


      if (!this._productService.selectedLocations.length || !this._productService.selectedLocations[0]) {
        for (let i = 0; i < x.length; i++)
          x[i].openingQty = 0
        this._productService.selectedLocations = x
      } else {
        const copy = JSON.parse(JSON.stringify(this._productService.selectedLocations))
        this._productService.selectedLocations = []
        for (let i = 0; i < copy.length; i++) {
          for (let j = 0; j < x.length; j++) {
            if (copy[i].id == x[j].id) {
              this._productService.selectedLocations.push(x[j])
              break
            }
          }
        }
      }
      for (let j = 0; j < this._productService.selectedLocations.length; j++) {
        let line = this._productService.selectedLocations[j]
        if (line.openingStock == null) line.openingStock = 0
      }
      if (this._productService.isNew) {
        this.totalStockOnHands = 0
        this._productService.variantLocationQohStocks = {}
        for (let j = 0; j < this._productService.selectedLocations.length; j++) {
          let line = this._productService.selectedLocations[j]
          // if (line.stockOnHand) line.stockOnHand = 0
          // if (line.openingStock) line.openingStock = 0
          // if (line.stockOnHandQoh) line.stockOnHandQoh = 0
          line.stockOnHand = 0
          line.stockOnHandQoh = 0

          // Old
          // if (!line.openingStock) line.openingStock = 0
          // New
          line.openingStock = 0

          try { delete line.newQoh }
          catch { }
        }
      }
      else {
        const itemIdOrCode = this.resolveItemIdForStockStatus()
        if (itemIdOrCode) {
          this._productService.getItemStockStatusV2(itemIdOrCode).subscribe(res => {
            if (res.success) {
              this.loading = true
              this.applyStockStatusV2Payload(res?.data)
            }
          })
        }
      }
      if (!this.activeVariantLocation) {
        this.activeVariantLocation = this._productService.selectedLocations?.[0] ?? null
      }
    }
  }

  gotoaddlocation() {
    this._router.navigate(['app/locations-list'])
  }

  calcMax(item) {
    if (this._productService.isNew) return 99999999999
    else return item.stockOnHand
  }
  changeQOH(e: any) {
    this._productService.QOHChange = true;
  }

  onLocationsChange(locs: any[]) {
    if (!Array.isArray(locs)) return
    for (let i = 0; i < locs.length; i++) {
      if (locs[i].openingStock == null) locs[i].openingStock = 0
    }
    if (!this.activeVariantLocation || !locs.includes(this.activeVariantLocation)) {
      this.activeVariantLocation = locs[0] ?? null
    }
  }

  normalizeStockValue(
    item: any,
    field: 'openingStock' | 'stockOnHand',
    defer = false
  ) {
    if (!item) return

    const apply = () => {
      const rawValue = item[field]
      if (rawValue === null || typeof rawValue === 'undefined') {
        item[field] = 0
        return
      }

      const normalized =
        typeof rawValue === 'string' ? rawValue.trim() : rawValue
      if (normalized === '') {
        item[field] = 0
        return
      }

      const numericValue = typeof normalized === 'number'
        ? normalized
        : Number(normalized)
      item[field] = Number.isFinite(numericValue) && numericValue >= 0
        ? numericValue
        : 0
    }

    if (defer) {
      setTimeout(apply)
    } else {
      apply()
    }
  }

  ok2showLocations() {
    if (this._abd.actLocations.length > 0 &&
      !this._productService.activeItem &&
      this._productService.selectedLocations.length > 0)
      return true

    return false
  }

  get hasVariants(): boolean {
    return Array.isArray(this._productService.variantAttributes) &&
      this._productService.variantAttributes.length > 0 &&
      Array.isArray(this._productService.variantRows) &&
      this._productService.variantRows.length > 0
  }

  get variantRows(): any[] {
    const rows = this._productService.variantRows || []
    return this.getVariantRowsInStockStatusOrder(rows)
  }

  get variantLocations(): any[] {
    return this._productService.selectedLocations || []
  }

  get hasMultipleLocations(): boolean {
    return this.variantLocations.length > 1
  }

  get useCompactVariantLayout(): boolean {
    return false
  }

  get enableVariantLocationSearch(): boolean {
    return (this.variantLocations?.length || 0) > 6
  }

  onVariantLocationSelect(location: any): void {
    this.activeVariantLocation = location
  }

  getVariantLabel(row: { options?: Record<string, string> }): string {
    return this.getOrderedVariantEntries(row?.options)
      .map(([, value]) => value)
      .join(' / ')
  }

  getVariantStock(row: { id: string; available?: number | null }): number {
    return this.getVariantStockForLocation(row, this.activeVariantLocation)
  }

  onVariantStockChange(row: { id: string }, value: number | string | null): void {
    this.onVariantStockChangeForLocation(row, this.activeVariantLocation, value)
  }

  getVariantQoh(row: { id: string; available?: number | null; sku?: string; skuId?: string | number | null; options?: Record<string, string> }): number {
    return this.getVariantQohForLocation(row, this.activeVariantLocation)
  }

  getVariantQohForLocation(
    row: { id: string; available?: number | null; sku?: string; skuId?: string | number | null; options?: Record<string, string> },
    location: any
  ): number {
    const locationId = this.getLocationId(location)
    const rowId = String(row?.id ?? '').trim()
    if (!locationId || !rowId) return 0
    if (!this._productService.isNew && this.serverMappedVariantRowIds.size > 0 && !this.serverMappedVariantRowIds.has(rowId)) {
      return 0
    }
    const locationKey = this.normalizeLocationKey(locationId)
    const qohBucket = this._productService.variantLocationQohStocks?.[locationKey]
    if (qohBucket) {
      const byRowId = qohBucket[row.id]
      if (byRowId !== undefined && byRowId !== null) return byRowId

      if (this.shouldUseSkuStockKeys()) {
        const bySku = qohBucket[this.getSkuStockKey(row?.sku)]
        if (bySku !== undefined && bySku !== null) return bySku

        const bySkuId = qohBucket[this.getSkuIdStockKey(row?.skuId)]
        if (bySkuId !== undefined && bySkuId !== null) return bySkuId
      }

      const byVariantLabel = qohBucket[this.getVariantLabelStockKey(this.getVariantLabelFromOptions(row?.options))]
      if (byVariantLabel !== undefined && byVariantLabel !== null) return byVariantLabel

      const byVariantValueLabel = qohBucket[this.getVariantLabelStockKey(this.getVariantValueLabelFromOptions(row?.options))]
      if (byVariantValueLabel !== undefined && byVariantValueLabel !== null) return byVariantValueLabel
    }
    return 0
  }

  getVariantStockForLocation(row: { id: string; available?: number | null; sku?: string; skuId?: string | number | null; options?: Record<string, string> }, location: any): number {
    this.tryApplyPendingVariantStocks()
    const locationId = this.getLocationId(location)
    const rowId = String(row?.id ?? '').trim()
    if (!locationId || !rowId) return 0
    if (!this._productService.isNew && this.serverMappedVariantRowIds.size > 0 && !this.serverMappedVariantRowIds.has(rowId)) {
      return 0
    }
    const locationKey = this.normalizeLocationKey(locationId)
    const stockBucket = this._productService.variantLocationStocks?.[locationKey]
    if (stockBucket) {
      const byRowId = stockBucket[row.id]
      if (byRowId !== undefined && byRowId !== null) return byRowId

      if (this.shouldUseSkuStockKeys()) {
        const bySku = stockBucket[this.getSkuStockKey(row?.sku)]
        if (bySku !== undefined && bySku !== null) return bySku

        const bySkuId = stockBucket[this.getSkuIdStockKey(row?.skuId)]
        if (bySkuId !== undefined && bySkuId !== null) return bySkuId
      }

      const byVariantLabel = stockBucket[this.getVariantLabelStockKey(this.getVariantLabelFromOptions(row?.options))]
      if (byVariantLabel !== undefined && byVariantLabel !== null) return byVariantLabel

      const byVariantValueLabel = stockBucket[this.getVariantLabelStockKey(this.getVariantValueLabelFromOptions(row?.options))]
      if (byVariantValueLabel !== undefined && byVariantValueLabel !== null) return byVariantValueLabel
    }
    if (!this._productService.isNew) return 0
    return typeof row.available === 'number' ? row.available : 0
  }

  onVariantStockChangeForLocation(row: { id: string; sku?: string; skuId?: string | number | null; options?: Record<string, string> }, location: any, value: number | string | null): void {
    const locationId = this.getLocationId(location)
    if (!locationId || !row?.id) return
    const normalized = this.normalizeVariantQuantity(value)
    const locationKey = this.normalizeLocationKey(locationId)
    this.pendingVariantStockEntries = []
    if (!this._productService.variantLocationStocks[locationKey]) {
      this._productService.variantLocationStocks[locationKey] = {}
    }
    this._productService.variantLocationStocks[locationKey][row.id] = normalized
  }

  onVariantQohChange(row: { id: string }, value: number | string | null): void {
    this.onVariantQohChangeForLocation(row, this.activeVariantLocation, value)
  }

  onVariantQohChangeForLocation(
    row: { id: string; sku?: string; skuId?: string | number | null; options?: Record<string, string> },
    location: any,
    value: number | string | null
  ): void {
    const locationId = this.getLocationId(location)
    if (!locationId || !row?.id) return
    const normalized = this.normalizeVariantQuantity(value)
    const locationKey = this.normalizeLocationKey(locationId)
    this.pendingVariantStockEntries = []
    if (!this._productService.variantLocationQohStocks[locationKey]) {
      this._productService.variantLocationQohStocks[locationKey] = {}
    }
    this._productService.variantLocationQohStocks[locationKey][row.id] = normalized

    this._productService.QOHChange = true
  }

  private getLocationId(location: any): string | number | null {
    if (!location) return null
    return (
      location.locationId ??
      location.LocationId ??
      location.locationID ??
      location.LocationID ??
      location.id ??
      location.Id ??
      null
    )
  }

  private normalizeVariantQuantity(value: number | string | null): number {
    if (value === null || value === undefined || value === '') return 0
    const parsed = typeof value === 'number' ? value : Number(String(value))
    if (!Number.isFinite(parsed)) return 0
    const whole = Math.trunc(parsed)
    return whole < 0 ? 0 : whole
  }

  private resolveItemIdForStockStatus(): string | null {
    const active = this._productService.activeItem || {}
    const fromItem =
      active?.id ??
      active?.Id ??
      active?.itemId ??
      active?.ItemId ??
      active?.productCode ??
      active?.ProductCode ??
      active?.itemCode ??
      active?.ItemCode
    if (fromItem !== undefined && fromItem !== null && String(fromItem).trim()) {
      return String(fromItem).trim()
    }
    const sku = active?.crsItemSKUs?.[0] ?? active?.ItemSKUs?.[0] ?? active?.itemSKUs?.[0] ?? {}
    const fromSku =
      sku?.productCode ??
      sku?.ProductCode ??
      sku?.skuCode ??
      sku?.SkuCode
    if (fromSku !== undefined && fromSku !== null && String(fromSku).trim()) {
      return String(fromSku).trim()
    }
    return null
  }

  private applyStockStatusV2Payload(data: any): void {
    const skuEntries = this.getSkuEntries(data)
    const rootTotalStockOnHands = this.toNumber(data?.totalStockOnHands ?? data?.TotalStockOnHands)
    if (!skuEntries.length) {
      const legacyDetails = this.getStockDetails(data)
      this.data = legacyDetails
      const totals = new Map<string, { openingStock: number; stockOnHands: number }>()
      legacyDetails.forEach((detail: any) => {
        const key = this.normalizeLocationKey(detail?.locationId ?? detail?.LocationId)
        if (!key) return
        const existing = totals.get(key) || { openingStock: 0, stockOnHands: 0 }
        existing.openingStock += this.getEffectiveOpeningStock(detail)
        existing.stockOnHands += this.toNumber(detail?.stockOnHands ?? detail?.StockOnHands)
        totals.set(key, existing)
      })
      this.totalStockOnHands = rootTotalStockOnHands || this.sumStockOnHandsFromTotals(totals)
      this.applyLocationTotals(totals, rootTotalStockOnHands)
      return
    }

    if (skuEntries.length === 1 && !this.hasVariants) {
      this.data = this.getStockDetails(skuEntries[0])
    } else {
      this.data = skuEntries
    }
    this.pendingVariantStockEntries = skuEntries
    const totals = new Map<string, { openingStock: number; stockOnHands: number }>()
    skuEntries.forEach((sku: any) => {
      const stockDetails = this.getStockDetails(sku)
      stockDetails.forEach((detail: any) => {
        const key = this.normalizeLocationKey(detail?.locationId ?? detail?.LocationId)
        if (!key) return
        const existing = totals.get(key) || { openingStock: 0, stockOnHands: 0 }
        existing.openingStock += this.getEffectiveOpeningStock(detail)
        existing.stockOnHands += this.toNumber(detail?.stockOnHands ?? detail?.StockOnHands)
        totals.set(key, existing)
      })
    })
    this.totalStockOnHands = rootTotalStockOnHands || this.sumStockOnHandsFromTotals(totals)
    this.applyLocationTotals(totals, rootTotalStockOnHands)
    this.applyVariantLocationStocksFromV2(skuEntries)
  }

  private applyLocationTotals(
    totals: Map<string, { openingStock: number; stockOnHands: number }>,
    rootTotalStockOnHands: number = 0
  ): void {
    for (let j = 0; j < this._productService.selectedLocations.length; j++) {
      const line = this._productService.selectedLocations[j]
      const key = this.normalizeLocationKey(line?.locationId ?? line?.locationID ?? line?.id)
      const matched = key ? totals.get(key) : undefined
      let stockOnHands = matched?.stockOnHands ?? 0
      const openingStock = matched?.openingStock ?? 0
      if (!matched && this._productService.selectedLocations.length === 1 && rootTotalStockOnHands > 0) {
        stockOnHands = rootTotalStockOnHands
      }
      line.newQoh = stockOnHands
      line.stockOnHand = stockOnHands
      line.stockOnHandQoh = stockOnHands
      line.openingStock = openingStock
    }
  }

  private applyVariantLocationStocksFromV2(skuEntries: any[], retryCount = 0): void {
    if (!Array.isArray(this._productService.variantRows) || !this._productService.variantRows.length) {
      if (retryCount < 8) {
        setTimeout(() => this.applyVariantLocationStocksFromV2(skuEntries, retryCount + 1), 150)
      }
      return
    }

    const rowIdBySkuCode = new Map<string, string>()
    const ambiguousSkuKeys = new Set<string>()
    const rowIdBySkuId = new Map<string, string>()
    const rowIdByVariantLabel = new Map<string, string>()
    const rowIdByVariantValueLabel = new Map<string, string>()
    const persistedVariantRowIds = new Set<string>()
    const variantRows = this._productService.variantRows || []
    variantRows.forEach((row: any) => {
      const skuCode = String(row?.sku ?? '').trim()
      const skuId = row?.skuId ?? row?.itemSKUId ?? row?.itemSkuId ?? row?.id
      const rowId = String(row?.id ?? '').trim()
      if (!rowId) return

      const persistedSkuId = row?.skuId ?? row?.itemSKUId ?? row?.itemSkuId
      if (this.hasValue(persistedSkuId)) {
        persistedVariantRowIds.add(rowId)
      }

      const skuKey = this.getSkuStockKey(skuCode)
      if (skuKey) {
        if (rowIdBySkuCode.has(skuKey) && rowIdBySkuCode.get(skuKey) !== rowId) {
          ambiguousSkuKeys.add(skuKey)
        }
        rowIdBySkuCode.set(skuKey, rowId)
      }

      const skuIdKey = this.getSkuIdStockKey(skuId)
      if (skuIdKey) rowIdBySkuId.set(skuIdKey, rowId)

      const variantLabelKey = this.getVariantLabelStockKey(this.getVariantLabelFromOptions(row?.options))
      if (variantLabelKey) rowIdByVariantLabel.set(variantLabelKey, rowId)

      const variantValueLabelKey = this.getVariantLabelStockKey(this.getVariantValueLabelFromOptions(row?.options))
      if (variantValueLabelKey) rowIdByVariantValueLabel.set(variantValueLabelKey, rowId)
    })
    ambiguousSkuKeys.forEach((key) => rowIdBySkuCode.delete(key))

    const locationStocks: Record<string, Record<string, number>> = {}
    const locationQohStocks: Record<string, Record<string, number>> = {}
    const totalByRowId = new Map<string, number>()
    const matchedRowIdsFromServer = new Set<string>()
    let mappedRows = 0
    let matchedSkuCount = 0
    const singleSelectedLocationId = this.variantLocations.length === 1
      ? this.normalizeLocationKey(this.getLocationId(this.variantLocations[0]))
      : ''

    skuEntries.forEach((sku: any, index: number) => {
      const skuCode = sku?.skuCode ?? sku?.SkuCode
      const skuId = sku?.itemSKUId ?? sku?.ItemSKUId ?? sku?.id ?? sku?.Id
      const variantLabel = sku?.variantLabel ?? sku?.VariantLabel
      const title = sku?.title ?? sku?.Title
      const variantLabelCandidates = this.getVariantLabelCandidates(variantLabel, title)
      let rowIds = this.resolveRowIdsForSku(
        skuCode,
        skuId,
        variantLabel,
        title,
        rowIdBySkuCode,
        rowIdBySkuId,
        rowIdByVariantLabel,
        rowIdByVariantValueLabel,
        variantRows
      )
      if (!rowIds.length && variantRows.length === skuEntries.length) {
        const ordinalRowId = String(variantRows[index]?.id ?? '').trim()
        if (ordinalRowId) {
          rowIds = [ordinalRowId]
        }
      }
      if (!rowIds.length) return
      const persistedRowIds = rowIds.filter((rowId) => persistedVariantRowIds.has(rowId))
      persistedRowIds.forEach((rowId) => {
        const normalizedRowId = String(rowId ?? '').trim()
        if (normalizedRowId) {
          matchedRowIdsFromServer.add(normalizedRowId)
        }
      })
      matchedSkuCount += 1
      mappedRows += rowIds.length

      let totalForRow = 0
      const stockDetails = this.getStockDetails(sku)
      if (stockDetails.length) {
        stockDetails.forEach((detail: any) => {
          const locationKey = this.normalizeLocationKey(detail?.locationId ?? detail?.LocationId)
          if (!locationKey) return
          const qty = this.getEffectiveOpeningStock(detail)
          const qoh = this.toNumber(detail?.stockOnHands ?? detail?.StockOnHands)
          totalForRow += qty
          if (!locationStocks[locationKey]) {
            locationStocks[locationKey] = {}
          }
          if (!locationQohStocks[locationKey]) {
            locationQohStocks[locationKey] = {}
          }
          persistedRowIds.forEach((rowId) => {
            this.upsertStockValue(locationStocks[locationKey], rowId, qty)
            this.upsertStockValue(locationQohStocks[locationKey], rowId, qoh)
          })

          const skuKey = this.getSkuStockKey(skuCode)
          if (skuKey) {
            this.upsertStockValue(locationStocks[locationKey], skuKey, qty)
            this.upsertStockValue(locationQohStocks[locationKey], skuKey, qoh)
          }

          const skuIdKey = this.getSkuIdStockKey(skuId)
          if (skuIdKey) {
            this.upsertStockValue(locationStocks[locationKey], skuIdKey, qty)
            this.upsertStockValue(locationQohStocks[locationKey], skuIdKey, qoh)
          }

          this.upsertVariantLabelCandidates(
            locationStocks[locationKey],
            locationQohStocks[locationKey],
            variantLabelCandidates,
            qty,
            qoh
          )
        })
      }
      const skuTotal = this.getEffectiveOpeningTotal(sku)
      if (skuTotal > 0 || totalForRow === 0) {
        totalForRow = skuTotal
      }
      const totalQohForRow = this.toNumber(sku?.totalStockOnHands ?? sku?.TotalStockOnHands)

      persistedRowIds.forEach((rowId) => {
        if (totalForRow > 0) {
          totalByRowId.set(rowId, totalForRow)
        }
      })

      if (singleSelectedLocationId) {
        if (!locationStocks[singleSelectedLocationId]) {
          locationStocks[singleSelectedLocationId] = {}
        }
        if (!locationQohStocks[singleSelectedLocationId]) {
          locationQohStocks[singleSelectedLocationId] = {}
        }
        persistedRowIds.forEach((rowId) => {
          this.upsertStockValue(locationStocks[singleSelectedLocationId], rowId, totalForRow)
          this.upsertStockValue(locationQohStocks[singleSelectedLocationId], rowId, totalQohForRow)
        })

        const skuKey = this.getSkuStockKey(skuCode)
        if (skuKey) {
          this.upsertStockValue(locationStocks[singleSelectedLocationId], skuKey, totalForRow)
          this.upsertStockValue(locationQohStocks[singleSelectedLocationId], skuKey, totalQohForRow)
        }

        const skuIdKey = this.getSkuIdStockKey(skuId)
        if (skuIdKey) {
          this.upsertStockValue(locationStocks[singleSelectedLocationId], skuIdKey, totalForRow)
          this.upsertStockValue(locationQohStocks[singleSelectedLocationId], skuIdKey, totalQohForRow)
        }

        this.upsertVariantLabelCandidates(
          locationStocks[singleSelectedLocationId],
          locationQohStocks[singleSelectedLocationId],
          variantLabelCandidates,
          totalForRow,
          totalQohForRow
        )
      }
    })

    const requiresFullMatch = skuEntries.length > 0
    const hasFullSkuMapping = !requiresFullMatch || matchedSkuCount >= skuEntries.length

    if ((!mappedRows || !hasFullSkuMapping) && retryCount < 8) {
      setTimeout(() => this.applyVariantLocationStocksFromV2(skuEntries, retryCount + 1), 150)
      return
    }

    this._productService.variantLocationStocks = locationStocks
    this._productService.variantLocationQohStocks = locationQohStocks
    this.serverMappedVariantRowIds = matchedRowIdsFromServer
    this._productService.variantRows = this._productService.variantRows.map((row: any) => {
      const rowId = String(row?.id ?? '').trim()
      if (!rowId || !totalByRowId.has(rowId)) return row
      return {
        ...row,
        available: totalByRowId.get(rowId)
      }
    })
    if (mappedRows && hasFullSkuMapping) {
      this.pendingVariantStockEntries = []
    }
  }

  private resolveRowIdsForSku(
    skuCode: any,
    skuId: any,
    variantLabel: any,
    title: any,
    rowIdBySkuCode: Map<string, string>,
    rowIdBySkuId: Map<string, string>,
    rowIdByVariantLabel: Map<string, string>,
    rowIdByVariantValueLabel: Map<string, string>,
    variantRows: any[]
  ): string[] {
    const titleDerivedLabel = this.extractVariantLabelFromTitle(title)
    const normalizedVariantValueLabel = this.getVariantValueLabelFromLabel(variantLabel)
    const normalizedTitleValueLabel = this.getVariantValueLabelFromLabel(titleDerivedLabel)
    const skuIdDirectRow = rowIdBySkuId.get(this.getSkuIdStockKey(skuId))
    const skuCodeDirectRow = this.shouldUseSkuStockKeys()
      ? rowIdBySkuCode.get(this.getSkuStockKey(skuCode))
      : ''
    const directRowId =
      skuIdDirectRow ||
      skuCodeDirectRow ||
      rowIdByVariantLabel.get(this.getVariantLabelStockKey(variantLabel)) ||
      rowIdByVariantLabel.get(this.getVariantLabelStockKey(titleDerivedLabel)) ||
      rowIdByVariantValueLabel.get(this.getVariantLabelStockKey(normalizedTitleValueLabel)) ||
      rowIdByVariantValueLabel.get(this.getVariantLabelStockKey(normalizedVariantValueLabel))
    if (directRowId) return [directRowId]
    const byVariantLabel = this.getRowIdsByPartialVariantLabel(variantLabel, variantRows)
    if (byVariantLabel.length) return byVariantLabel
    const byTitleLabel = this.getRowIdsByPartialVariantLabel(titleDerivedLabel, variantRows)
    if (byTitleLabel.length) return byTitleLabel
    const byTitleMatch = this.getRowIdsByTitleMatch(titleDerivedLabel, variantRows)
    if (byTitleMatch.length) return byTitleMatch
    return this.getRowIdsByVariantValueSignatureMatch(titleDerivedLabel, variantRows)
  }

  private extractVariantLabelFromTitle(title: any): string {
    const raw = String(title ?? '').trim()
    if (!raw) return ''
    const marker = ' - '
    const idx = raw.lastIndexOf(marker)
    if (idx >= 0) return raw.substring(idx + marker.length).trim()
    return raw
  }

  private getVariantLabelCandidates(variantLabel: any, title: any): string[] {
    const candidates = new Set<string>()
    const pushCandidate = (value: any): void => {
      const normalized = String(value ?? '').trim()
      if (!normalized) return
      candidates.add(normalized)
      const valueOnly = this.getVariantValueLabelFromLabel(normalized)
      if (valueOnly) {
        candidates.add(valueOnly)
      }
    }

    pushCandidate(variantLabel)
    pushCandidate(this.extractVariantLabelFromTitle(title))

    return Array.from(candidates)
  }

  private upsertVariantLabelCandidates(
    stockBucket: Record<string, number>,
    qohBucket: Record<string, number>,
    labels: string[],
    qty: number,
    qoh: number
  ): void {
    if (!Array.isArray(labels) || !labels.length) return
    labels.forEach((label) => {
      const key = this.getVariantLabelStockKey(label)
      if (!key) return
      this.upsertStockValue(stockBucket, key, qty)
      this.upsertStockValue(qohBucket, key, qoh)
    })
  }

  private getRowIdsByTitleMatch(titleVariantLabel: any, variantRows: any[]): string[] {
    const normalizedTitle = this.normalizeMatchToken(this.getVariantValueLabelFromLabel(titleVariantLabel))
    if (!normalizedTitle || !Array.isArray(variantRows) || !variantRows.length) return []

    const matched: string[] = []
    variantRows.forEach((row: any) => {
      const rowId = String(row?.id ?? '').trim()
      if (!rowId) return
      const rowLabel = this.getVariantValueLabelFromOptions(row?.options)
      if (this.normalizeMatchToken(rowLabel) === normalizedTitle) {
        matched.push(rowId)
      }
    })
    return matched
  }

  private getRowIdsByVariantValueSignatureMatch(titleVariantLabel: any, variantRows: any[]): string[] {
    const titleSignature = this.getVariantValueSignature(titleVariantLabel)
    if (!titleSignature || !Array.isArray(variantRows) || !variantRows.length) return []

    const matched: string[] = []
    variantRows.forEach((row: any) => {
      const rowId = String(row?.id ?? '').trim()
      if (!rowId) return
      const rowSignature = this.getVariantValueSignature(this.getVariantValueLabelFromOptions(row?.options))
      if (rowSignature === titleSignature) {
        matched.push(rowId)
      }
    })
    return matched
  }

  private getRowIdsByPartialVariantLabel(variantLabel: any, variantRows: any[]): string[] {
    const labelOptions = this.parseVariantLabelOptions(variantLabel)
    const entries = Object.entries(labelOptions)
    if (!entries.length || !Array.isArray(variantRows) || !variantRows.length) return []

    const matched: string[] = []
    variantRows.forEach((row: any) => {
      const rowId = String(row?.id ?? '').trim()
      if (!rowId) return

      const rowOptions: Record<string, string> = {}
      Object.entries(row?.options || {}).forEach(([key, value]) => {
        rowOptions[this.normalizeMatchToken(key)] = this.normalizeMatchToken(value)
      })

      const isMatch = entries.every(([name, value]) => {
        const key = this.normalizeMatchToken(name)
        return rowOptions[key] === this.normalizeMatchToken(value)
      })
      if (isMatch) matched.push(rowId)
    })
    return matched
  }

  private parseVariantLabelOptions(variantLabel: any): Record<string, string> {
    const label = String(variantLabel ?? '').trim()
    if (!label) return {}

    const options: Record<string, string> = {}
    label.split(/[\/,]/).forEach((part) => {
      const segment = String(part ?? '').trim()
      if (!segment || !segment.includes(':')) return
      const [rawName, ...rest] = segment.split(':')
      const name = String(rawName ?? '').trim()
      const value = rest.join(':').trim()
      if (!name || !value) return
      options[name] = value
    })
    return options
  }

  private normalizeMatchToken(value: any): string {
    return String(value ?? '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase()
  }

  private getVariantValueSignature(value: any): string {
    const normalized = this.getVariantValueLabelFromLabel(value)
    if (!normalized) return ''

    return normalized
      .split('/')
      .map((part) => this.normalizeMatchToken(part))
      .filter((part) => !!part)
      .sort((left, right) => left.localeCompare(right))
      .join('|')
  }

  private upsertStockValue(bucket: Record<string, number>, key: string, value: number): void {
    if (!bucket || !key) return
    const next = this.toNumber(value)
    const current = this.toNumber(bucket[key])
    if (next === 0 && current > 0) return
    bucket[key] = next
  }

  private normalizeLocationKey(value: any): string {
    if (value === undefined || value === null) return ''
    return String(value).trim()
  }

  private shouldUseSkuStockKeys(): boolean {
    return this._productService?.useParentSkuBarcodeForVariants !== true
  }

  private toNumber(value: any): number {
    if (value === undefined || value === null || value === '') return 0
    const parsed = typeof value === 'number' ? value : Number(String(value))
    return Number.isFinite(parsed) ? parsed : 0
  }

  private sumStockOnHandsFromTotals(totals: Map<string, { openingStock: number; stockOnHands: number }>): number {
    let total = 0
    totals.forEach((value) => {
      total += this.toNumber(value?.stockOnHands)
    })
    return total
  }

  private getSkuEntries(data: any): any[] {
    const candidates = [data?.SKUs, data?.skUs, data?.SkUs]
    for (const entry of candidates) {
      if (Array.isArray(entry)) return entry
    }
    return []
  }

  private getStockDetails(target: any): any[] {
    const candidates = [target?.StockDetails, target?.stockDetails]
    for (const entry of candidates) {
      if (Array.isArray(entry)) return entry
    }
    return []
  }

  private getEffectiveOpeningStock(detail: any): number {
    if (this.hasValue(detail?.openingStock) || this.hasValue(detail?.OpeningStock)) {
      return this.toNumber(detail?.openingStock ?? detail?.OpeningStock)
    }
    const openingStock = this.toNumber(detail?.openingStock ?? detail?.OpeningStock)
    const stockOnHands = this.toNumber(detail?.stockOnHands ?? detail?.StockOnHands)
    if (openingStock > 0) return openingStock
    return stockOnHands
  }

  private getEffectiveOpeningTotal(sku: any): number {
    if (this.hasValue(sku?.totalOpeningStock) || this.hasValue(sku?.TotalOpeningStock)) {
      return this.toNumber(sku?.totalOpeningStock ?? sku?.TotalOpeningStock)
    }

    if (this.hasValue(sku?.openingStock) || this.hasValue(sku?.OpeningStock)) {
      return this.toNumber(sku?.openingStock ?? sku?.OpeningStock)
    }

    return 0
  }

  private tryApplyPendingVariantStocks(): void {
    if (!Array.isArray(this.pendingVariantStockEntries) || !this.pendingVariantStockEntries.length) return
    if (!Array.isArray(this._productService.variantRows) || !this._productService.variantRows.length) return
    this.applyVariantLocationStocksFromV2(this.pendingVariantStockEntries)
  }

  private getSkuStockKey(skuCode: any): string {
    const raw = String(skuCode ?? '').trim()
    if (!raw) return ''
    if (/^\d+$/.test(raw)) {
      const normalized = raw.replace(/^0+/, '') || '0'
      return `sku:${normalized}`
    }
    return `sku:${raw.toLowerCase()}`
  }

  private getSkuIdStockKey(skuId: any): string {
    const value = String(skuId ?? '').trim()
    if (!value) return ''
    return `skuid:${value.toLowerCase()}`
  }

  private getVariantLabelStockKey(variantLabel: any): string {
    const value = String(variantLabel ?? '')
      .replace(/\s+/g, '')
      .trim()
      .toLowerCase()
    if (!value) return ''
    return `vlabel:${value}`
  }

  private getVariantLabelFromOptions(options: Record<string, string> | undefined): string {
    return this.getOrderedVariantEntries(options)
      .map(([name, value]) => `${name}: ${value}`)
      .join(' / ')
  }

  private getVariantValueLabelFromOptions(options: Record<string, string> | undefined): string {
    return this.getOrderedVariantEntries(options)
      .map(([, value]) => value)
      .join(' / ')
  }

  private getVariantValueLabelFromLabel(variantLabel: any): string {
    const options = this.parseVariantLabelOptions(variantLabel)
    const optionEntries = Object.entries(options)
    if (optionEntries.length) {
      const optionOrder = Array.isArray(this._productService.variantAttributes)
        ? this._productService.variantAttributes
          .map((option: any) => String(option?.name ?? option?.Name ?? '').trim())
          .filter((name: string) => !!name)
        : []
      const values: string[] = []
      const used = new Set<string>()
      optionOrder.forEach((name) => {
        const value = options[name]
        if (value === undefined || value === null || String(value).trim() === '') return
        values.push(String(value).trim())
        used.add(name)
      })
      optionEntries.forEach(([name, value]) => {
        if (used.has(name)) return
        if (!String(value ?? '').trim()) return
        values.push(String(value).trim())
      })
      return values.join(' / ')
    }

    const raw = String(variantLabel ?? '').trim()
    if (!raw) return ''
    return raw
      .replace(/[,\|]/g, '/')
      .split('/')
      .map((value) => String(value ?? '').trim())
      .filter((value) => !!value)
      .join(' / ')
  }

  private getOrderedVariantEntries(options: Record<string, string> | undefined): Array<[string, string]> {
    if (!options) return []

    const ordered: Array<[string, string]> = []
    const used = new Set<string>()
    const optionOrder = Array.isArray(this._productService.variantAttributes)
      ? this._productService.variantAttributes
        .map((option: any) => String(option?.name ?? option?.Name ?? '').trim())
        .filter((name: string) => !!name)
      : []

    optionOrder.forEach((optionName: string) => {
      const value = options[optionName]
      if (value === undefined || value === null || String(value).trim() === '') return
      ordered.push([optionName, String(value)])
      used.add(optionName)
    })

    Object.entries(options).forEach(([name, value]) => {
      if (used.has(name)) return
      if (value === undefined || value === null || String(value).trim() === '') return
      ordered.push([name, String(value)])
    })

    return ordered
  }

  private hasValue(value: any): boolean {
    return value !== undefined && value !== null && String(value).trim() !== ''
  }

  private getVariantRowsInStockStatusOrder(rows: any[]): any[] {
    if (!Array.isArray(rows) || rows.length < 2) return rows || []

    const skuEntries = this.getSkuEntries(this.data)
    if (!skuEntries.length) return rows

    const rowIdBySkuCode = new Map<string, string>()
    const ambiguousSkuKeys2 = new Set<string>()
    const rowIdBySkuId = new Map<string, string>()
    const rowIdByVariantLabel = new Map<string, string>()
    const rowIdByVariantValueLabel = new Map<string, string>()
    const originalIndexByRowId = new Map<string, number>()

    rows.forEach((row: any, index: number) => {
      const rowId = String(row?.id ?? '').trim()
      if (!rowId) return
      originalIndexByRowId.set(rowId, index)

      const skuKey = this.getSkuStockKey(row?.sku)
      if (skuKey) {
        if (rowIdBySkuCode.has(skuKey) && rowIdBySkuCode.get(skuKey) !== rowId) {
          ambiguousSkuKeys2.add(skuKey)
        }
        rowIdBySkuCode.set(skuKey, rowId)
      }

      const skuIdKey = this.getSkuIdStockKey(row?.skuId ?? row?.itemSKUId ?? row?.itemSkuId)
      if (skuIdKey) rowIdBySkuId.set(skuIdKey, rowId)

      const variantLabelKey = this.getVariantLabelStockKey(this.getVariantLabelFromOptions(row?.options))
      if (variantLabelKey) rowIdByVariantLabel.set(variantLabelKey, rowId)

      const variantValueLabelKey = this.getVariantLabelStockKey(this.getVariantValueLabelFromOptions(row?.options))
      if (variantValueLabelKey) rowIdByVariantValueLabel.set(variantValueLabelKey, rowId)
    })
    ambiguousSkuKeys2.forEach((key) => rowIdBySkuCode.delete(key))

    const orderByRowId = new Map<string, number>()
    let nextOrder = 0
    skuEntries.forEach((sku: any) => {
      const rowIds = this.resolveRowIdsForSku(
        sku?.skuCode ?? sku?.SkuCode,
        sku?.itemSKUId ?? sku?.ItemSKUId ?? sku?.id ?? sku?.Id,
        sku?.variantLabel ?? sku?.VariantLabel,
        sku?.title ?? sku?.Title,
        rowIdBySkuCode,
        rowIdBySkuId,
        rowIdByVariantLabel,
        rowIdByVariantValueLabel,
        rows
      )
      rowIds.forEach((rowId) => {
        if (!orderByRowId.has(rowId)) {
          orderByRowId.set(rowId, nextOrder++)
        }
      })
    })

    if (!orderByRowId.size) return rows

    return [...rows].sort((a: any, b: any) => {
      const aId = String(a?.id ?? '').trim()
      const bId = String(b?.id ?? '').trim()
      const aOrder = orderByRowId.has(aId) ? (orderByRowId.get(aId) as number) : Number.MAX_SAFE_INTEGER
      const bOrder = orderByRowId.has(bId) ? (orderByRowId.get(bId) as number) : Number.MAX_SAFE_INTEGER
      if (aOrder !== bOrder) return aOrder - bOrder

      const aIndex = originalIndexByRowId.has(aId) ? (originalIndexByRowId.get(aId) as number) : Number.MAX_SAFE_INTEGER
      const bIndex = originalIndexByRowId.has(bId) ? (originalIndexByRowId.get(bId) as number) : Number.MAX_SAFE_INTEGER
      return aIndex - bIndex
    })
  }



}
